import { connect } from 'react-redux'
import { getProp } from '../../../../../../redux/selectors/kegCollectionBookings'
import KegCollectionDeleteModal from './KegCollectionDeleteModal'

const mapStateToProps = state => {
  const {
    bookingDetails: { deleteKegCollectionRequestStatusState, bookingData },
  } = getProp(state)
  return {
    deleteKegCollectionRequestStatusState,
    bookingData,
  }
}

export default connect(mapStateToProps)(KegCollectionDeleteModal)
